import { useQuery } from "@tanstack/react-query";
import { getDealTrends } from "@/api";
import { DealTrend } from "@/types";

export const useDealTrends = () => {
  const query = useQuery<DealTrend[]>({
    queryKey: ["dealTrends"],
    queryFn: () => getDealTrends(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};